import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const MintBtn = styled(Button)({
  height: "36px",
  lineHeight: "36px",
  maxHeight: "36px",
  width: "128px",
  color: "#000000",
  fontSize: 14,
  fontFamily: "Gill Sans",
  textTransform: "uppercase",
  background: "#22D758",
  border: "none",
  borderRadius: "8px",
  "&:hover": {
    background: "#37FF73",
    color: "#000000",
  },
});
